import {
  Bestellung,
  BestellungTrinkgeldRequest,
  TrinkgeldType,
  RemoteResult,
} from "mangdto"
import BaseLogic from "../base_logic"
import Formatter from "../formatter"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import router from "@/router"
import RouteNames from "@/util/route_names"

export default class TrinkgeldBestellungLogic extends BaseLogic {
  bestellung: Bestellung

  gesamtpreis: number
  prozent5: number
  prozent10: number
  andererBetrag: number
  type: TrinkgeldType = TrinkgeldType.Percent10

  init() {
    this.bestellung = this.mainLogic.bestellung
    var warenkorb = this.bestellung.artikelliste
    this.gesamtpreis = Formatter.berechnePreisListe(warenkorb)

    this.prozent5 = this.gesamtpreis * 0.05
    this.prozent10 = this.gesamtpreis * 0.1
  }

  weiter() {
    var betrag: number = 0

    var request = new BestellungTrinkgeldRequest()
    request.bestellungId = this.bestellung.id
    request.type = this.type

    if (this.type == TrinkgeldType.Percent5) {
      betrag = this.gesamtpreis * 0.05
    } else if (this.type == TrinkgeldType.Percent10) {
      betrag = this.gesamtpreis * 0.1
    } else if (this.type == TrinkgeldType.Custom) {
      betrag = this.andererBetrag
    }

    request.betrag = betrag

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungKundeTrinkgeldFestlegen,
      request,
    ).then((response) => {
      if (response.data.success) {
        router.push({
          name: RouteNames.BESTELLUNG_PAGE.BEZAHLUNG_WEITERLEITEN,
          params: {
            bestellungId: this.bestellung.id,
          },
        })
      }
    })
  }
}
